import { isMobile } from 'is-mobile';

export const getDevicePlatform = () => {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) {
    return 'ios';
  }
  if (/Android/.test(ua)) {
    return 'android';
  }
  if (isMobile()) {
    return 'mobile-web';
  }
  return 'web';
};

// Binary mobile-web/web only, unlike getDevicePlatform()'s ios/android split.
export const getWebDevicePlatform = (): 'mobile-web' | 'web' =>
  isMobile() ? 'mobile-web' : 'web';
